import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/http/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReceptionService extends DataService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  create(data: any) {
    return this.post(data, '?ctrl=reception&action=creer');
  }
  supprimer(id: any) {
    return this.delete(id, '?ctrl=reception&action=supprimer');
  }

  updateDechargement(data: any) {
    return this.update(data, '?ctrl=reception&action=modifier');
  }

  saveDepart(data: any) {
    return this.update(data, '?ctrl=reception&action=saveDepart');
  }

  calculer(data: any) {
    return this.post(data, '?ctrl=reception&action=calculer');
  }
}
